import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NoAuthGuard, AuthGuard } from '../core';
import { CoreModule } from '../core/core.module';
import { SharedModule } from '../shared/shared.module';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthUserComponent } from './auth-user.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    AuthRoutingModule
  ],
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    AuthUserComponent,
    AccountSettingsComponent
  ],
  exports: [FormsModule, ReactiveFormsModule],
  providers: [NoAuthGuard, AuthGuard],
})
export class AuthModule {}
